import { StringConditions } from '../../../grid/gridFilters/types';
import { ColumnDetails, ColumnType } from '../../../grid/types/common';

export enum Column {
  EVENT_TIME,

  NETWORK_HOSTNAME,
  NETWORK_URI,
  NETWORK_DESTINATION_IP,
  NETWORK_SOURCE_IP,
  NETWORK_DESTINATION_PORT,
  NETWORK_SOURCE_PORT,
  NETWORK_CONTAINER_ID,
  NETWORK_CONTAINER_NAME,
  NETWORK_OPERATION,
  NETWORK_DOMAIN_NAME,
  NETWORK_MAC,

  PROCESS_PID,
  PROCESS_PATH,
  PROCESS_USER,
  PROCESS_COMMAND_LINE,
  PROCESS_ACCESS_PRIVILEGES,
  PROCESS_NAME,
  PROCESS_SHA256,
  PROCESS_MD5,
  PROCESS_SERVICE_NAME,
  PROCESS_SERVICE_START_TYPE,
  PROCESS_IS_DRIVER,
  PROCESS_TARGET_PATH,
  PROCESS_TARGET_NAME,
  PROCESS_TASK_NAME,
  PROCESS_INJECTION_METHOD,
  PROCESS_INJECTION_WRITER_PID,
  PROCESS_INJECTION_TARGET_PID,
  PROCESS_INJECTION_WRITER_PATH,
  PROCESS_INJECTION_TARGET_PATH,
  PROCESS_NEW_SERVICE_NAME,
  PROCESS_BUFFER,
  PROCESS_CREATE_TYPE,

  FILE_OPERATION,
  FILE_PATH,
  FILE_OLD_PATH,
  FILE_SIZE,
  FILE_NAME,
  FILE_EXT,
  FILE_URL,
  FILE_SITE,
  FILE_DESTINATION_URL,
  FILE_DESTINATION_FILE,
  FILE_ITEM_TYPE,
  FILE_IS_REMOTE,

  REGISTRY_OPERATION,
  REGISTRY_KEY,
  REGISTRY_VALUE,

  RESOURCE_NAME,
  RESOURCE_TYPE,
  RESOURCE_DATA,
  RESOURCE_ID,
  RESOURCE_APP_ADDRESS,
  RESOURCE_POLICY_TYPE,
  RESOURCE_URL,
  RESOURCE_PATH,
  RESOURCE_SIZE,
  RESOURCE_MD5,
  RESOURCE_SHA256,
  RESOURCE_SSH_PUBLIC_KEY,

  EMAIL_SENDER,
  EMAIL_SENDER_ADDRESS,
  EMAIL_SENDER_NAME,
  EMAIL_RECEIVER,
  EMAIL_RECEIVER_ADDRESS,
  EMAIL_RECEIVER_NAME,
  EMAIL_SUBJECT,
  EMAIL_ORIGIN_IP,
  EMAIL_ATTACHMENTS_NUMBER,
  EMAIL_ATTACHMENTS_SIZE,
  EMAIL_PATH,
  EMAIL_MAILBOX_OWNER,
  EMAIL_MAILBOX_GUID,
  EMAIL_LOGON_TYPE,
  EMAIL_LOGIN_STATUS,
  EMAIL_CLIENT,
  EMAIL_PARAMETERS,
  EMAIL_ID,
  EMAIL_TO_ADDRESS,
  EMAIL_TO_NAME,
  EMAIL_FROM_ADDRESS,
  EMAIL_FROM_NAME,
  EMAIL_CC_ADDRESS,
  EMAIL_CC_NAME,
  EMAIL_BCC_ADDRESS,
  EMAIL_BCC_NAME,

  ALERT_ID,
  ALERT_NAME,
  ALERT_DESCRIPTION,
  ALERT_TYPE,
  ALERT_MARK,
  ALERT_ACTIONS_TAKEN,
  ALERT_INCIDENT_NUMBER,
  ALERT_SEVERITY_SCORE,

  USER_NAME,
  USER_EMAIL,
  USER_TYPE,
  USER_ID,
  USER_DOMAIN,
  USER_SHARED_WITH,
  USER_TARGET,
  USER_SHARING_PERMISSIONS,
  USER_MODIFIED_PROPERTIES,
  USER_TEAM_NAME,
  USER_TEAM_GUID,
  USER_TEAM_MEMBERS,
  USER_EXTENDED_PROPERTIES,
  USER_EXTERNAL_ACCESS,
  USER_LOGON_TYPE,
  USER_OPERATION,

  OTHER_HOSTNAME,
  OTHER_EVENT_TYPE,
  OTHER_EVENT_NAME,
  OTHER_OS,
  OTHER_USER,
  OTHER_SENSOR_NAME,
  OTHER_DETECTION_CLASS,
  OTHER_AGENT,
  OTHER_SCRIPT,
  OTHER_COMPLIANCE_CENTER_EVENT,
  OTHER_RESULT_STATUS,
  OTHER_RECORD_TYPE,
  OTHER_ORGANIZATION_ID,
  OTHER_COUNT,
  OTHER_RULE_ID,
}

export enum ColumnKeys {
  EVENT_TIME = 'eventTime',

  NETWORK_HOSTNAME = 'networkHostname',
  NETWORK_URI = 'networkUri',
  NETWORK_DESTINATION_IP = 'networkDestinationIp',
  NETWORK_SOURCE_IP = 'networkSourceIp',
  NETWORK_DESTINATION_PORT = 'networkDestinationPort',
  NETWORK_SOURCE_PORT = 'networkSourcePort',
  NETWORK_CONTAINER_ID = 'networkContainerId',
  NETWORK_CONTAINER_NAME = 'networkContainerName',
  NETWORK_OPERATION = 'networkOperation',
  NETWORK_DOMAIN_NAME = 'networkDomainName',
  NETWORK_MAC = 'networkMac',

  PROCESS_PID = 'processPid',
  PROCESS_PATH = 'processPath',
  PROCESS_USER = 'processUser',
  PROCESS_COMMAND_LINE = 'processCommandLine',
  PROCESS_ACCESS_PRIVILEGES = 'processAccessPrivileges',
  PROCESS_NAME = 'processName',
  PROCESS_SHA256 = 'processSha256',
  PROCESS_MD5 = 'processMd5',
  PROCESS_SERVICE_NAME = 'processServiceName',
  PROCESS_SERVICE_START_TYPE = 'processServiceStartType',
  PROCESS_IS_DRIVER = 'processIsDriver',
  PROCESS_TARGET_PATH = 'processTargetPath',
  PROCESS_TARGET_NAME = 'processTargetName',
  PROCESS_TASK_NAME = 'processTaskName',
  PROCESS_INJECTION_METHOD = 'processInjectionMethod',
  PROCESS_INJECTION_WRITER_PID = 'processInjectionWriterPid',
  PROCESS_INJECTION_TARGET_PID = 'processInjectionTargetPid',
  PROCESS_INJECTION_WRITER_PATH = 'processInjectionWriterPath',
  PROCESS_INJECTION_TARGET_PATH = 'processInjectionTargetPath',
  PROCESS_NEW_SERVICE_NAME = 'processNewServiceName',
  PROCESS_BUFFER = 'processBuffer',
  PROCESS_CREATE_TYPE = 'processCreateType',

  FILE_OPERATION = 'fileOperation',
  FILE_PATH = 'filePath',
  FILE_OLD_PATH = 'fileOldPath',
  FILE_SIZE = 'fileSize',
  FILE_NAME = 'fileName',
  FILE_EXT = 'fileExt',
  FILE_URL = 'fileUrl',
  FILE_SITE = 'fileSite',
  FILE_DESTINATION_URL = 'fileDestinationUrl',
  FILE_DESTINATION_FILE = 'fileDestinationFile',
  FILE_ITEM_TYPE = 'fileItemType',
  FILE_IS_REMOTE = 'fileIsRemote',

  REGISTRY_OPERATION = 'registryOperation',
  REGISTRY_KEY = 'registryKey',
  REGISTRY_VALUE = 'registryValue',

  RESOURCE_NAME = 'resourceName',
  RESOURCE_TYPE = 'resourceType',
  RESOURCE_DATA = 'resourceData',
  RESOURCE_ID = 'resourceId',
  RESOURCE_APP_ADDRESS = 'resourceAppAddress',
  RESOURCE_POLICY_TYPE = 'resourcePolicyType',
  RESOURCE_URL = 'resourceUrl',
  RESOURCE_PATH = 'resourcePath',
  RESOURCE_SIZE = 'resourceSize',
  RESOURCE_MD5 = 'resourceMd5',
  RESOURCE_SHA256 = 'resourceSha256',
  RESOURCE_SSH_PUBLIC_KEY = 'resourceSshPublicKey',

  EMAIL_SENDER = 'emailSender',
  EMAIL_SENDER_ADDRESS = 'emailSenderAddress',
  EMAIL_SENDER_NAME = 'emailSenderName',
  EMAIL_RECEIVER = 'emailReceiver',
  EMAIL_RECEIVER_ADDRESS = 'emailReceiverAddress',
  EMAIL_RECEIVER_NAME = 'emailReceiverName',
  EMAIL_SUBJECT = 'emailSubject',
  EMAIL_ORIGIN_IP = 'emailOriginIp',
  EMAIL_ATTACHMENTS_NUMBER = 'emailAttachmentsNumber',
  EMAIL_ATTACHMENTS_SIZE = 'emailAttachmentsSize',
  EMAIL_PATH = 'emailPath',
  EMAIL_MAILBOX_OWNER = 'emailMailboxOwner',
  EMAIL_MAILBOX_GUID = 'emailMailboxGuid',
  EMAIL_LOGON_TYPE = 'emailLogonType',
  EMAIL_LOGIN_STATUS = 'emailLoginStatus',
  EMAIL_CLIENT = 'emailClient',
  EMAIL_PARAMETERS = 'emailParameters',
  EMAIL_ID = 'emailId',
  EMAIL_TO_ADDRESS = 'emailToAddress',
  EMAIL_TO_NAME = 'emailToName',
  EMAIL_FROM_ADDRESS = 'emailFromAddress',
  EMAIL_FROM_NAME = 'emailFromName',
  EMAIL_CC_ADDRESS = 'emailCcAddress',
  EMAIL_CC_NAME = 'emailCcName',
  EMAIL_BCC_ADDRESS = 'emailBccAddress',
  EMAIL_BCC_NAME = 'emailBccName',

  ALERT_ID = 'alertId',
  ALERT_NAME = 'alertName',
  ALERT_DESCRIPTION = 'alertDescription',
  ALERT_TYPE = 'alertType',
  ALERT_MARK = 'alertMark',
  ALERT_ACTIONS_TAKEN = 'alertActionsTaken',
  ALERT_INCIDENT_NUMBER = 'alertIncidentNumber',
  ALERT_SEVERITY_SCORE = 'alertSeverityScore',

  USER_NAME = 'userName',
  USER_EMAIL = 'userEmail',
  USER_TYPE = 'userType',
  USER_ID = 'userId',
  USER_DOMAIN = 'userDomain',
  USER_SHARED_WITH = 'userSharedWith',
  USER_TARGET = 'userTarget',
  USER_SHARING_PERMISSIONS = 'userSharingPermissions',
  USER_MODIFIED_PROPERTIES = 'userModifiedProperties',
  USER_TEAM_NAME = 'userTeamName',
  USER_TEAM_GUID = 'userTeamGuid',
  USER_TEAM_MEMBERS = 'userTeamMembers',
  USER_EXTENDED_PROPERTIES = 'userExtendedProperties',
  USER_EXTERNAL_ACCESS = 'userExternalAccess',
  USER_LOGON_TYPE = 'userLogonType',
  USER_OPERATION = 'userOperation',

  OTHER_AGENT = 'otherAgent',
  OTHER_COMPLIANCE_CENTER_EVENT = 'otherComplianceCenterEvent',
  OTHER_RESULT_STATUS = 'otherResultStatus',
  OTHER_RECORD_TYPE = 'otherRecordType',
  OTHER_ORGANIZATION_ID = 'otherOrganizationId',
  OTHER_HOSTNAME = 'otherHostname',
  OTHER_EVENT_TYPE = 'otherEventType',
  OTHER_EVENT_NAME = 'otherEventName',
  OTHER_OS = 'otherOs',
  OTHER_SCRIPT = 'otherScript',
  OTHER_USER = 'otherUser',
  OTHER_SENSOR_NAME = 'otherSensorName',
  OTHER_DETECTION_CLASS = 'otherDetectionClass',
  OTHER_COUNT = 'otherCount',
  OTHER_RULE_ID = 'otherRuleId',
}

export const ENDPOINT_ID_KEY = 'endpointId';

export const FILTERS = [];

export const COLUMNS = [
  Column.EVENT_TIME,
  Column.OTHER_HOSTNAME,
  Column.OTHER_EVENT_TYPE,
  Column.OTHER_EVENT_NAME,
  Column.ALERT_SEVERITY_SCORE,
  Column.OTHER_OS,
  Column.OTHER_USER,
  Column.OTHER_SENSOR_NAME,
  Column.OTHER_DETECTION_CLASS,
  Column.FILE_PATH,
  Column.FILE_NAME,
  Column.USER_NAME,
  Column.USER_EMAIL,
  Column.USER_DOMAIN,
  Column.NETWORK_DESTINATION_IP,
  Column.NETWORK_SOURCE_IP,
  Column.PROCESS_PATH,
  Column.PROCESS_NAME,
  Column.REGISTRY_KEY,
  Column.REGISTRY_VALUE,
  Column.EMAIL_SUBJECT,
  Column.EMAIL_SENDER,
  Column.EMAIL_SENDER_NAME,
  Column.EMAIL_SENDER_ADDRESS,
  Column.EMAIL_RECEIVER,
  Column.EMAIL_RECEIVER_NAME,
  Column.EMAIL_RECEIVER_ADDRESS,
  Column.ALERT_NAME,
  Column.ALERT_TYPE,
  Column.OTHER_COUNT,
];

export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.OTHER_COUNT];

export interface Filter {
  eventTime?: StringConditions;
  eventName?: StringConditions;
}

export interface DataGridItem {
  eventTime?: string;
  eventName?: string;
}

export interface GetDataGridItemsResponse {
  rawEvents?: Array<DataGridItem>;
}

export interface SetFiltersRequest {
  viewId: string;
  filters: Array<Filter>;
}

export enum XdrSearchResultsDetailsPanelEvents {
  REFINE_SEARCH_FROM_SIDE_PANEL = 'refineSearchFromSidePanel',
}

export function getColumnDetails(translateFn) {
  return [
    {
      column: Column.EVENT_TIME,
      key: ColumnKeys.EVENT_TIME,
      columnName: 'event_time',
      type: ColumnType.DATE,
      removable: false,
      editingDisabled: true,
      category: translateFn('common columns'),
    },
    {
      column: Column.OTHER_HOSTNAME,
      key: ColumnKeys.OTHER_HOSTNAME,
      columnName: 'other.hostname',
      type: ColumnType.STRING,
      removable: false,
      category: translateFn('other'),
    },
    {
      column: Column.OTHER_EVENT_TYPE,
      key: ColumnKeys.OTHER_EVENT_TYPE,
      columnName: 'other.event_type',
      type: ColumnType.STRING,
      removable: false,
      category: translateFn('other'),
    },
    {
      column: Column.OTHER_EVENT_NAME,
      key: ColumnKeys.OTHER_EVENT_NAME,
      columnName: 'other.event_name',
      type: ColumnType.STRING,
      removable: false,
      category: translateFn('other'),
    },
    {
      column: Column.ALERT_SEVERITY_SCORE,
      key: ColumnKeys.ALERT_SEVERITY_SCORE,
      columnName: 'alert.severity_score',
      type: ColumnType.STRING,
      removable: false,
      category: translateFn('alert'),
    },
    {
      column: Column.OTHER_OS,
      key: ColumnKeys.OTHER_OS,
      columnName: 'other.os',
      type: ColumnType.STRING,
      removable: false,
      category: translateFn('other'),
    },
    {
      column: Column.OTHER_USER,
      key: ColumnKeys.OTHER_USER,
      columnName: 'other.user',
      type: ColumnType.STRING,
      removable: false,
      category: translateFn('other'),
    },
    {
      column: Column.OTHER_SENSOR_NAME,
      key: ColumnKeys.OTHER_SENSOR_NAME,
      columnName: 'other.sensor_name',
      type: ColumnType.STRING,
      removable: false,
      category: translateFn('other'),
    },
    {
      column: Column.OTHER_DETECTION_CLASS,
      key: ColumnKeys.OTHER_DETECTION_CLASS,
      columnName: 'other.detection_class',
      type: ColumnType.STRING,
      removable: false,
      category: translateFn('other'),
    },
    {
      column: Column.OTHER_COUNT,
      key: ColumnKeys.OTHER_COUNT,
      columnName: 'other.count',
      type: ColumnType.NUMBER,
      removable: false,
      category: translateFn('other'),
    },
    {
      column: Column.NETWORK_HOSTNAME,
      key: ColumnKeys.NETWORK_HOSTNAME,
      columnName: 'network.hostname',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('network'),
    },
    {
      column: Column.NETWORK_URI,
      key: ColumnKeys.NETWORK_URI,
      columnName: 'network.uri',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('network'),
    },
    {
      column: Column.NETWORK_DESTINATION_IP,
      key: ColumnKeys.NETWORK_DESTINATION_IP,
      columnName: 'network.destination_ip',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('network'),
    },
    {
      column: Column.NETWORK_SOURCE_IP,
      key: ColumnKeys.NETWORK_SOURCE_IP,
      columnName: 'network.source_ip',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('network'),
    },
    {
      column: Column.NETWORK_DESTINATION_PORT,
      key: ColumnKeys.NETWORK_DESTINATION_PORT,
      columnName: 'network.destination_port',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('network'),
    },
    {
      column: Column.NETWORK_MAC,
      key: ColumnKeys.NETWORK_MAC,
      columnName: 'network.mac',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('network'),
    },
    {
      column: Column.NETWORK_SOURCE_PORT,
      key: ColumnKeys.NETWORK_SOURCE_PORT,
      columnName: 'network.source_port',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('network'),
    },
    {
      column: Column.NETWORK_CONTAINER_ID,
      key: ColumnKeys.NETWORK_CONTAINER_ID,
      columnName: 'network.container_id',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('network'),
    },
    {
      column: Column.NETWORK_CONTAINER_NAME,
      key: ColumnKeys.NETWORK_CONTAINER_NAME,
      columnName: 'network.container_name',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('network'),
    },
    {
      column: Column.NETWORK_OPERATION,
      key: ColumnKeys.NETWORK_OPERATION,
      columnName: 'network.operation',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('network'),
    },
    {
      column: Column.NETWORK_DOMAIN_NAME,
      key: ColumnKeys.NETWORK_DOMAIN_NAME,
      columnName: 'network.domain_name',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('network'),
    },
    {
      column: Column.PROCESS_PID,
      key: ColumnKeys.PROCESS_PID,
      columnName: 'process.pid',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_PATH,
      key: ColumnKeys.PROCESS_PATH,
      columnName: 'process.path',
      type: ColumnType.STRING,
      removable: true,
      width: '200px',
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_USER,
      key: ColumnKeys.PROCESS_USER,
      columnName: 'process.user',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_COMMAND_LINE,
      key: ColumnKeys.PROCESS_COMMAND_LINE,
      columnName: 'process.command_line',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_ACCESS_PRIVILEGES,
      key: ColumnKeys.PROCESS_ACCESS_PRIVILEGES,
      columnName: 'process.access_privileges',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_NAME,
      key: ColumnKeys.PROCESS_NAME,
      columnName: 'process.name',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_BUFFER,
      key: ColumnKeys.PROCESS_BUFFER,
      columnName: 'process.buffer',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_SHA256,
      key: ColumnKeys.PROCESS_SHA256,
      columnName: 'process.sha256',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_MD5,
      key: ColumnKeys.PROCESS_MD5,
      columnName: 'process.md5',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_SERVICE_NAME,
      key: ColumnKeys.PROCESS_SERVICE_NAME,
      columnName: 'process.service_name',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_CREATE_TYPE,
      key: ColumnKeys.PROCESS_CREATE_TYPE,
      columnName: 'process.create_type',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_NEW_SERVICE_NAME,
      key: ColumnKeys.PROCESS_NEW_SERVICE_NAME,
      columnName: 'process.new_service_name',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_SERVICE_START_TYPE,
      key: ColumnKeys.PROCESS_SERVICE_START_TYPE,
      columnName: 'process.service_start_type',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_IS_DRIVER,
      key: ColumnKeys.PROCESS_IS_DRIVER,
      columnName: 'process.is_driver',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_TARGET_PATH,
      key: ColumnKeys.PROCESS_TARGET_PATH,
      columnName: 'process.target_path',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_TARGET_NAME,
      key: ColumnKeys.PROCESS_TARGET_NAME,
      columnName: 'process.target_name',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_TASK_NAME,
      key: ColumnKeys.PROCESS_TASK_NAME,
      columnName: 'process.task_name',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_INJECTION_METHOD,
      key: ColumnKeys.PROCESS_INJECTION_METHOD,
      columnName: 'process.injection_method',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_INJECTION_WRITER_PID,
      key: ColumnKeys.PROCESS_INJECTION_WRITER_PID,
      columnName: 'process.injection_writer_pid',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_INJECTION_TARGET_PID,
      key: ColumnKeys.PROCESS_INJECTION_TARGET_PID,
      columnName: 'process.injection_target_pid',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_INJECTION_WRITER_PATH,
      key: ColumnKeys.PROCESS_INJECTION_WRITER_PATH,
      columnName: 'process.injection_writer_path',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.PROCESS_INJECTION_TARGET_PATH,
      key: ColumnKeys.PROCESS_INJECTION_TARGET_PATH,
      columnName: 'process.injection_target_path',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('process'),
    },
    {
      column: Column.FILE_OPERATION,
      key: ColumnKeys.FILE_OPERATION,
      columnName: 'file.operation',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('file'),
    },
    {
      column: Column.FILE_PATH,
      key: ColumnKeys.FILE_PATH,
      columnName: 'file.path',
      type: ColumnType.STRING,
      removable: true,
      width: '200px',
      category: translateFn('file'),
    },
    {
      column: Column.FILE_OLD_PATH,
      key: ColumnKeys.FILE_OLD_PATH,
      columnName: 'file.old_path',
      type: ColumnType.STRING,
      removable: true,
      width: '200px',
      category: translateFn('file'),
    },
    {
      column: Column.FILE_SIZE,
      key: ColumnKeys.FILE_SIZE,
      columnName: 'file.size',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('file'),
    },
    {
      column: Column.FILE_IS_REMOTE,
      key: ColumnKeys.FILE_IS_REMOTE,
      columnName: 'file.is_remote',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('file'),
    },

    {
      column: Column.RESOURCE_NAME,
      key: ColumnKeys.RESOURCE_NAME,
      columnName: 'resource.name',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('resource'),
      editingDisabled: true,
    },
    {
      column: Column.RESOURCE_TYPE,
      key: ColumnKeys.RESOURCE_TYPE,
      columnName: 'resource.type',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('resource'),
      editingDisabled: true,
    },
    {
      column: Column.RESOURCE_DATA,
      key: ColumnKeys.RESOURCE_DATA,
      columnName: 'resource.data',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('resource'),
      editingDisabled: true,
    },
    {
      column: Column.RESOURCE_ID,
      key: ColumnKeys.RESOURCE_ID,
      columnName: 'resource.id',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('resource'),
      editingDisabled: true,
    },
    {
      column: Column.RESOURCE_APP_ADDRESS,
      key: ColumnKeys.RESOURCE_APP_ADDRESS,
      columnName: 'resource.app_address',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('resource'),
      editingDisabled: true,
    },
    {
      column: Column.RESOURCE_POLICY_TYPE,
      key: ColumnKeys.RESOURCE_POLICY_TYPE,
      columnName: 'resource.policy_type',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('resource'),
      editingDisabled: true,
    },
    {
      column: Column.RESOURCE_URL,
      key: ColumnKeys.RESOURCE_URL,
      columnName: 'resource.url',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('resource'),
      editingDisabled: true,
    },
    {
      column: Column.RESOURCE_PATH,
      key: ColumnKeys.RESOURCE_PATH,
      columnName: 'resource.path',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('resource'),
      editingDisabled: true,
    },
    {
      column: Column.RESOURCE_SIZE,
      key: ColumnKeys.RESOURCE_SIZE,
      columnName: 'resource.size',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('resource'),
      editingDisabled: true,
    },
    {
      column: Column.RESOURCE_MD5,
      key: ColumnKeys.RESOURCE_MD5,
      columnName: 'resource.md5',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('resource'),
      editingDisabled: true,
    },
    {
      column: Column.RESOURCE_SHA256,
      key: ColumnKeys.RESOURCE_SHA256,
      columnName: 'resource.sha256',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('resource'),
      editingDisabled: true,
    },
    {
      column: Column.RESOURCE_SSH_PUBLIC_KEY,
      key: ColumnKeys.RESOURCE_SSH_PUBLIC_KEY,
      columnName: 'resource.ssh_public_key',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('resource'),
      editingDisabled: true,
    },

    {
      column: Column.REGISTRY_OPERATION,
      key: ColumnKeys.REGISTRY_OPERATION,
      columnName: 'registry.operation',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('registry'),
    },
    {
      column: Column.REGISTRY_KEY,
      key: ColumnKeys.REGISTRY_KEY,
      columnName: 'registry.key',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('registry'),
    },
    {
      column: Column.REGISTRY_VALUE,
      key: ColumnKeys.REGISTRY_VALUE,
      columnName: 'registry.value',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('registry'),
    },

    {
      column: Column.EMAIL_SENDER,
      key: ColumnKeys.EMAIL_SENDER,
      columnName: 'email.sender',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_SENDER_NAME,
      key: ColumnKeys.EMAIL_SENDER_NAME,
      columnName: 'email.sender_name',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_SENDER_ADDRESS,
      key: ColumnKeys.EMAIL_SENDER_ADDRESS,
      columnName: 'email.sender_address',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_RECEIVER,
      key: ColumnKeys.EMAIL_RECEIVER,
      columnName: 'email.receiver',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_RECEIVER_NAME,
      key: ColumnKeys.EMAIL_RECEIVER_NAME,
      columnName: 'email.receiver_name',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_RECEIVER_ADDRESS,
      key: ColumnKeys.EMAIL_RECEIVER_ADDRESS,
      columnName: 'email.receiver_address',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_SUBJECT,
      key: ColumnKeys.EMAIL_SUBJECT,
      columnName: 'email.subject',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_ORIGIN_IP,
      key: ColumnKeys.EMAIL_ORIGIN_IP,
      columnName: 'email.origin_ip',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_ATTACHMENTS_NUMBER,
      key: ColumnKeys.EMAIL_ATTACHMENTS_NUMBER,
      columnName: 'email.attachments_number',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_ATTACHMENTS_SIZE,
      key: ColumnKeys.EMAIL_ATTACHMENTS_SIZE,
      columnName: 'email.attachments_size',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
      editingDisabled: true,
    },
    {
      column: Column.EMAIL_PATH,
      key: ColumnKeys.EMAIL_PATH,
      columnName: 'email.path',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_MAILBOX_OWNER,
      key: ColumnKeys.EMAIL_MAILBOX_OWNER,
      columnName: 'email.mailbox_owner',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_MAILBOX_GUID,
      key: ColumnKeys.EMAIL_MAILBOX_GUID,
      columnName: 'email.mailbox_guid',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_LOGON_TYPE,
      key: ColumnKeys.EMAIL_LOGON_TYPE,
      columnName: 'email.logon_type',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_LOGIN_STATUS,
      key: ColumnKeys.EMAIL_LOGIN_STATUS,
      columnName: 'email.login_status',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_CLIENT,
      key: ColumnKeys.EMAIL_CLIENT,
      columnName: 'email.client',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_PARAMETERS,
      key: ColumnKeys.EMAIL_PARAMETERS,
      columnName: 'email.parameters',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('email'),
    },
    {
      column: Column.EMAIL_ID,
      key: ColumnKeys.EMAIL_ID,
      columnName: 'email.id',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
      editingDisabled: true,
    },
    {
      column: Column.EMAIL_TO_ADDRESS,
      key: ColumnKeys.EMAIL_TO_ADDRESS,
      columnName: 'email.to_address',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
      editingDisabled: true,
    },
    {
      column: Column.EMAIL_TO_NAME,
      key: ColumnKeys.EMAIL_TO_NAME,
      columnName: 'email.to_name',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
      editingDisabled: true,
    },
    {
      column: Column.EMAIL_FROM_ADDRESS,
      key: ColumnKeys.EMAIL_FROM_ADDRESS,
      columnName: 'email.from_address',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
      editingDisabled: true,
    },
    {
      column: Column.EMAIL_FROM_NAME,
      key: ColumnKeys.EMAIL_FROM_NAME,
      columnName: 'email.from_name',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
      editingDisabled: true,
    },
    {
      column: Column.EMAIL_CC_ADDRESS,
      key: ColumnKeys.EMAIL_CC_ADDRESS,
      columnName: 'email.cc_address',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
      editingDisabled: true,
    },
    {
      column: Column.EMAIL_CC_NAME,
      key: ColumnKeys.EMAIL_CC_NAME,
      columnName: 'email.cc_name',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
      editingDisabled: true,
    },
    {
      column: Column.EMAIL_BCC_ADDRESS,
      key: ColumnKeys.EMAIL_BCC_ADDRESS,
      columnName: 'email.bcc_address',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
      editingDisabled: true,
    },
    {
      column: Column.EMAIL_BCC_NAME,
      key: ColumnKeys.EMAIL_BCC_NAME,
      columnName: 'email.bcc_name',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('email'),
      editingDisabled: true,
    },
    {
      column: Column.ALERT_ID,
      key: ColumnKeys.ALERT_ID,
      columnName: 'alert.id',
      type: ColumnType.NUMBER,
      removable: true,
      category: translateFn('alert'),
    },
    {
      column: Column.ALERT_NAME,
      key: ColumnKeys.ALERT_NAME,
      columnName: 'alert.name',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('alert'),
    },
    {
      column: Column.ALERT_DESCRIPTION,
      key: ColumnKeys.ALERT_DESCRIPTION,
      columnName: 'alert.description',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('alert'),
      editingDisabled: true,
    },
    {
      column: Column.ALERT_TYPE,
      key: ColumnKeys.ALERT_TYPE,
      columnName: 'alert.type',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('alert'),
    },
    {
      column: Column.ALERT_MARK,
      key: ColumnKeys.ALERT_MARK,
      columnName: 'alert.mark',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('alert'),
    },
    {
      column: Column.ALERT_ACTIONS_TAKEN,
      key: ColumnKeys.ALERT_ACTIONS_TAKEN,
      columnName: 'alert.actions_taken',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('alert'),
    },
    {
      column: Column.ALERT_INCIDENT_NUMBER,
      key: ColumnKeys.ALERT_INCIDENT_NUMBER,
      columnName: 'alert.incident_number',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('alert'),
    },

    {
      column: Column.OTHER_AGENT,
      key: ColumnKeys.OTHER_AGENT,
      columnName: 'other.agent',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('other'),
    },
    {
      column: Column.OTHER_SCRIPT,
      key: ColumnKeys.OTHER_SCRIPT,
      columnName: 'other.script',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('other'),
    },
    {
      column: Column.OTHER_COMPLIANCE_CENTER_EVENT,
      key: ColumnKeys.OTHER_COMPLIANCE_CENTER_EVENT,
      columnName: 'other.compliance_center_event',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('other'),
    },
    {
      column: Column.OTHER_RESULT_STATUS,
      key: ColumnKeys.OTHER_RESULT_STATUS,
      columnName: 'other.result_status',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('other'),
    },
    {
      column: Column.OTHER_RECORD_TYPE,
      key: ColumnKeys.OTHER_RECORD_TYPE,
      columnName: 'other.record_type',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('other'),
    },
    {
      column: Column.OTHER_RULE_ID,
      key: ColumnKeys.OTHER_RULE_ID,
      columnName: 'other.rule_id',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('other'),
    },
    {
      column: Column.OTHER_ORGANIZATION_ID,
      key: ColumnKeys.OTHER_ORGANIZATION_ID,
      columnName: 'other.organization_id',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('other'),
    },
    {
      column: Column.USER_NAME,
      key: ColumnKeys.USER_NAME,
      columnName: 'user.name',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_EMAIL,
      key: ColumnKeys.USER_EMAIL,
      columnName: 'user.email',
      type: ColumnType.MULTIPLE_VALUE,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_TYPE,
      key: ColumnKeys.USER_TYPE,
      columnName: 'user.type',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_ID,
      key: ColumnKeys.USER_ID,
      columnName: 'user.id',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_DOMAIN,
      key: ColumnKeys.USER_DOMAIN,
      columnName: 'user.domain',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_SHARED_WITH,
      key: ColumnKeys.USER_SHARED_WITH,
      columnName: 'user.shared_with',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_TARGET,
      key: ColumnKeys.USER_TARGET,
      columnName: 'user.target',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_SHARING_PERMISSIONS,
      key: ColumnKeys.USER_SHARING_PERMISSIONS,
      columnName: 'user.sharing_permissions',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_MODIFIED_PROPERTIES,
      key: ColumnKeys.USER_MODIFIED_PROPERTIES,
      columnName: 'user.modified_properties',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_TEAM_NAME,
      key: ColumnKeys.USER_TEAM_NAME,
      columnName: 'user.team_name',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_TEAM_GUID,
      key: ColumnKeys.USER_TEAM_GUID,
      columnName: 'user.team_guid',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_TEAM_MEMBERS,
      key: ColumnKeys.USER_TEAM_MEMBERS,
      columnName: 'user.team_members',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_EXTENDED_PROPERTIES,
      key: ColumnKeys.USER_EXTENDED_PROPERTIES,
      columnName: 'user.extended_properties',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_EXTERNAL_ACCESS,
      key: ColumnKeys.USER_EXTERNAL_ACCESS,
      columnName: 'user.external_access',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_LOGON_TYPE,
      key: ColumnKeys.USER_LOGON_TYPE,
      columnName: 'user.logon_type',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.USER_OPERATION,
      key: ColumnKeys.USER_OPERATION,
      columnName: 'user.operation',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('user'),
    },
    {
      column: Column.FILE_NAME,
      key: ColumnKeys.FILE_NAME,
      columnName: 'file.name',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('file'),
    },
    {
      column: Column.FILE_EXT,
      key: ColumnKeys.FILE_EXT,
      columnName: 'file.ext',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('file'),
    },
    {
      column: Column.FILE_URL,
      key: ColumnKeys.FILE_URL,
      columnName: 'file.url',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('file'),
    },
    {
      column: Column.FILE_SITE,
      key: ColumnKeys.FILE_SITE,
      columnName: 'file.site',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('file'),
    },
    {
      column: Column.FILE_DESTINATION_URL,
      key: ColumnKeys.FILE_DESTINATION_URL,
      columnName: 'file.destination_url',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('file'),
    },
    {
      column: Column.FILE_DESTINATION_FILE,
      key: ColumnKeys.FILE_DESTINATION_FILE,
      columnName: 'file.destination_file',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('file'),
    },
    {
      column: Column.FILE_ITEM_TYPE,
      key: ColumnKeys.FILE_ITEM_TYPE,
      columnName: 'file.item_type',
      type: ColumnType.STRING,
      removable: true,
      category: translateFn('file'),
    },
  ];
}

export interface XdrSearchResultsPanelData {
  targets: string[];
  isPartner: boolean;
  allColumns: ColumnDetails<Column, ColumnKeys>[];
  views: any[];
  defaultViewProps: any[];
}

export interface EventDetailsPanel {
  eventName: string;
  severity: number;
  severityTitle: string;
  severityHigh: string;
  severityMedium: string;
  severityLow: string;
  detailsTitle: string;
  detectedByTitle: string;
  detectedOnTitle: string;
  detectedBy: string;
  detectedOn: string;
  jsonTitle: string;
  tableTitle: string;
  typeTitle: string;
  type: string;
  rawEvent: object;
  searchableFields: string[];
  showMore: string;
  showLess: string;
  emptyJsonText: string;
  copyBtnString: string;
  confirmationCopy: string;
}
